<template>
    <div>
        <slot :toggle="() => showModal = !showModal" name="activator"/>

        <b-modal
            id="da11ExportModal"
            v-model="showModal"
            :title="$t('DA11 Export')"
            size="lg"
            centered
            @close="form.reset()"
        >
            <template #modal-footer>
                <b-button :disabled="form.busy" type="submit" variant="primary" @click="handleSubmit">
                    {{ $t('Export') }}

                    <b-spinner v-if="form.busy" small/>
                    <fa v-else class="ml-1" icon="save"/>
                </b-button>
            </template>

            <b-form @submit.prevent="handleSubmit">
                <b-form-group v-slot="{ ariaDescribedby }" :label="$t('DA11 Export type')">
                    <b-form-radio-group
                        id="da11-export-sortBy"
                        v-model="form.sortBy"
                        :aria-describedby="ariaDescribedby"
                        :options="sortByOptions"
                        name="sortBy"
                    />
                </b-form-group>

                <b-form-group v-slot="{ ariaDescribedby }" :label="$t('DA11 Export scope')">
                    <b-form-radio-group
                        id="da11-export-onlyCompleted"
                        v-model="form.onlyCompleted"
                        :aria-describedby="ariaDescribedby"
                        :options="onlyCompletedOptions"
                        name="onlyCompleted"
                    />
                </b-form-group>

                <template v-if="form.onlyCompleted">
                    <label for="export_date_start">{{$t('DA11 Export date')}}</label>

                    <b-form-datepicker
                        id="export_date_start"
                        v-model="form.startDate"
                        :locale="$i18n.locale"
                        today-button
                        reset-button
                    />
                </template>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
import Form from "vform";

const SortByService = 'service';
const SortByProject = 'project';

export default {
    name: 'Da11Export',
    props: {
        projectId: {
            type: Number,
            required: true
        },

        lastExport: {
            type: String,
        }
    },
    data() {
        return {
            sortByOptions: [
                {
                    text: this.$t("DA11 Export by Service"),
                    value: SortByService
                }, {
                    text: this.$t("DA11 Export by Project"),
                    value: SortByProject
                }
            ],
            onlyCompletedOptions: [
                {
                    text: this.$t("DA11 Export complete"),
                    value: false
                }, {
                    text: this.$t("DA11 Export only completed"),
                    value: true
                }
            ],
            form: new Form({
                sortBy: SortByService,
                onlyCompleted: false,
                startDate: this.lastExport
            }),
            showModal: false,
        }
    },
    methods: {

        async handleSubmit() {
            let {message} = await this.form.post(`/api/projects/${this.projectId}/da11-export`).then(({data}) => data);

            this.successToast(message)

            this.showModal = false;
        },
    },
  watch: {
      'lastExport': function(newValue) {
        this.form.startDate = newValue
      }
  }

}
</script>

<style scoped>
fieldset + fieldset {
    padding-top: unset;
    margin-top:  unset;
    border-top:  unset;
}
</style>
